import { Pipe, PipeTransform } from '@angular/core';
import { RecentSearchTypeEnum } from '../../services';
import { translationKeys } from '../../core';

@Pipe({
  name: 'recentSearchType'
})
export class RecentSearchTypePipe implements PipeTransform {
  transform(value: RecentSearchTypeEnum): string {
    if (value === RecentSearchTypeEnum.Products) {
      return translationKeys.enums.recentSearchTypeEnum.products;
    } else if (value === RecentSearchTypeEnum.Submissions) {
      return translationKeys.enums.recentSearchTypeEnum.submissions;
    }
    return '';
  }
}
